<div class="my-1 skeleton-shimmer relative rounded-2xl border">
  <div>
    <div class="w-full bg-[#e1e5e8] pb-[56%]"></div>
  </div>

  <div class="p-3 space-y-3">
    <div class="h-28 bg-[#e1e5e8]"></div>
    <div class="pt-2 w-full border-t flex justify-between gap-2">
      <div class="h-10 basis-[50%] bg-[#e1e5e8]"></div>
      <div class="h-10 basis-[50%] bg-[#e1e5e8]"></div>
    </div>
  </div>
</div>
